export const transformInventoryResults = (results, inventorySrpPath) => {
	let transformedResults = [];
	if (results.length > 1 || (results.length === 1 && results[0].count)) {
		transformedResults = results
			.filter((item) => item.count > 0)
			.map(({ suggestion, count, facetInfo }) => {
				return {
					title: suggestion,
					count,
					facets: Object.keys(facetInfo).join(','),
					path: facetInfo
						? `${inventorySrpPath}?${Object.keys(facetInfo)
								.map(
									(key) =>
										`${encodeURIComponent(
											key
										)}=${encodeURIComponent(
											facetInfo[key]
										)}`
								)
								.join('&')}`
						: inventorySrpPath
				};
			});
	}
	return transformedResults;
};

export const makeAllLinkPath = (
	results,
	inventorySrpPath,
	transformedResults,
	nlsFacets
) => {
	const validResults = results.filter(({ count }) => count > 0);

	// Check if nlsFacets has data
	const nlsValue =
		nlsFacets && Object.keys(nlsFacets).length > 0 ? nlsFacets : null;

	if (nlsValue) {
		// if nls is present, use nls value
		const queryString = Object.keys(nlsValue)
			.map(
				(key) =>
					`${encodeURIComponent(key)}=${encodeURIComponent(
						nlsValue[key]
					)}`
			)
			.join('&');
		return `${inventorySrpPath}?${queryString}`;
	} else if (
		// else if first suggestion has valid model, concatenate models
		validResults.length > 0 &&
		validResults[0].facetInfo?.model !== undefined
	) {
		const models = validResults
			.filter((item) => item.facetInfo.model !== undefined)
			.map((item) => item.facetInfo.model);

		const uniqueModels = [...new Set(models)];
		let queryString = '';
		if (uniqueModels.length > 0) {
			queryString += uniqueModels
				.map((model) => `model=${encodeURIComponent(model)}`)
				.join('&');
		}
		return `${inventorySrpPath}?${queryString}`;
	} else if (validResults.length > 0 && validResults?.[0]?.count > 1) {
		// else if first suggestion has has no valid model, use first suggestion path - usually a make
		return transformedResults?.[0]?.path;
	} else {
		return '';
	}
};
